document.addEventListener('DOMContentLoaded', () => {
    'use strict'

    // Select all tables in the document
    let tables = document.getElementsByTagName("table");

    // Iterate over each table
    for(let i = 0; i < tables.length; i++){
        // Add the class to the table
        tables[i].classList.add("table");
    }

    /*==================================
     TOOLTIP
    ==================================*/
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    /*==================================
     COPY
    ==================================*/
    new ClipboardJS('.btn');

    /*==================================
     OS PREFERS COLOR SCHEME
    ==================================*/
    function detectColorScheme() {
        var theme = "light";

        if (localStorage.getItem("theme")) {
            if (localStorage.getItem("theme") == "dark") {
                var theme = "dark";
            }
        } else if (!window.matchMedia) {
            return false;
        } else if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
            var theme = "dark";
        }

        if (theme == "dark") {
            document.documentElement.setAttribute("data-theme", "dark");
        }

    }
    detectColorScheme();

    /*==================================
     DARK MODE ACTIVATION - SWITCH
    ==================================*/
    const toggleSwitch = document.querySelector('.theme-switch');
    function switchTheme(e) {
        if (e.target.checked) {
            localStorage.setItem('theme', 'dark');
            document.documentElement.setAttribute('data-theme', 'dark');
            toggleSwitch.checked = true;
        } else {
            localStorage.setItem('theme', 'light');
            document.documentElement.setAttribute('data-theme', 'light');
            toggleSwitch.checked = false;
        }
    }
    toggleSwitch.addEventListener('change', switchTheme, false);
    if (document.documentElement.getAttribute("data-theme") == "dark") {
        toggleSwitch.checked = true;
    }

    /*==================================
       MAKES THE CURRENT LINK CONTAINING A OF CLASS "ACTIVE"
      ==================================*/
    const activePage = window.location.pathname;
    const navLinks = document.querySelectorAll('.active-links a').forEach(link => {
        if (link.href.includes(`${activePage}`)) {
            link.classList.add('active');
        }
    });

    var sticky = new Sticky('.sticky');


    /*==================================
     MEDIA QUERY
    ==================================*/
    /*
    if (window.matchMedia('(min-width: 600px)').matches) {
        // SIMPLEBAR
        new SimpleBar(document.querySelector('#autoComplete_list_1'), {
            autoHide: false,
        });
    }
    */

}); //End. DOMContentLoaded

